import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SectionReveal } from './ui/SectionReveal';
import { useLanguage } from '../context/LanguageContext';
export function DeveloperSection() {
  const {
    t
  } = useLanguage();
  const [showArchitect, setShowArchitect] = useState(false);
  const [showEnergy, setShowEnergy] = useState(false);
  return <SectionReveal id="quienes-somos" className="bg-white py-24" data-id="element-127">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl" data-id="element-128">
        <h2 className="text-4xl md:text-6xl font-serif text-navy text-center mb-16" data-id="element-129">
          {t.developer.title}
        </h2>

        {/* Top Cards Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-130">
          {/* Promotora Tab (Flush with bottom section on desktop) */}
          <div className="hidden md:flex flex-col justify-end" data-id="element-131">
            <div className="bg-sand p-8 w-full" data-id="element-132">
              <h3 className="text-white font-bold text-xl" data-id="element-133">
                {t.developer.tabs.promoter}
              </h3>
            </div>
          </div>

          {/* Arquitectos */}
          <div className="bg-[#5b82b8] p-8 flex flex-col justify-between min-h-[160px]" data-id="element-134">
            <h3 className="text-white font-bold text-xl" data-id="element-135">
              {t.developer.tabs.architects}
            </h3>
            <button type="button" onClick={() => setShowArchitect(v => !v)} aria-expanded={showArchitect} className="text-white text-sm hover:underline mt-8 inline-block text-left" data-id="element-136">
              {t.developer.learnMore}
            </button>
          </div>

          {/* Calificación */}
          <div className="bg-navy p-8 flex flex-col justify-between min-h-[160px]" data-id="element-137">
            <h3 className="text-white font-bold text-xl" data-id="element-138">
              {t.developer.tabs.energy}
            </h3>
            <button type="button" onClick={() => setShowEnergy(v => !v)} aria-expanded={showEnergy} className="text-white text-sm hover:underline mt-8 inline-block text-left" data-id="element-139">
              {t.developer.learnMore}
            </button>
          </div>
        </div>

        {/* Arquitectos detail panel */}
        <AnimatePresence initial={false} data-id="element-140">
          {showArchitect && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-141">
              <div className="bg-[#5b82b8]/10 border-l-4 border-[#5b82b8] p-8 md:p-10 mt-6" data-id="element-142">
                <h4 className="font-serif text-2xl text-navy mb-4" data-id="element-143">
                  {t.developer.architect.name}
                </h4>
                <div className="space-y-4 text-navy/80 text-lg leading-relaxed max-w-3xl" data-id="element-144">
                  <p data-id="element-145">{t.developer.architect.p1}</p>
                  <p data-id="element-146">{t.developer.architect.p2}</p>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>

        {/* Calificación energética detail panel */}
        <AnimatePresence initial={false} data-id="element-147">
          {showEnergy && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-148">
              <div className="bg-navy/5 border-l-4 border-navy p-8 md:p-10 mt-6" data-id="element-149">
                <h4 className="font-serif text-2xl text-navy mb-4" data-id="element-150">
                  {t.developer.energy.title}
                </h4>
                <div className="space-y-4 text-navy/80 text-lg leading-relaxed max-w-3xl" data-id="element-151">
                  <p data-id="element-152">{t.developer.energy.p1}</p>
                  <p data-id="element-153">{t.developer.energy.p2}</p>
                  <p data-id="element-154">{t.developer.energy.p3}</p>
                  <p data-id="element-155">{t.developer.energy.p4}</p>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>

        {/* Bottom Content Area */}
        <div className="bg-sand p-8 md:p-12" data-id="element-156">
          <div className="md:hidden mb-8" data-id="element-157">
            <h3 className="text-white font-bold text-xl border-b border-white/20 pb-4" data-id="element-158">
              {t.developer.tabs.promoter}
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-159">
            {/* Left: Logo Card */}
            <div className="bg-white p-8 md:p-12 shadow-xl flex items-center justify-center aspect-video md:aspect-[4/3]" data-id="element-160">
              <img src="https://cdn.magicpatterns.com/uploads/eWststvYB2BbqkWme1dX8N/ChatGPT_Image_11_jun_2026,_17_15_05.png" alt="PIBASA Logo" className="w-full h-auto object-contain max-w-[85%]" data-id="element-161" />
            </div>

            {/* Right: Text Content */}
            <div className="text-white" data-id="element-162">
              <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-163">PIBASA</h3>
              <div className="space-y-6 text-white/90 text-lg leading-relaxed" data-id="element-164">
                <p className="font-bold" data-id="element-165">{t.developer.pibasa.p1}</p>
                <p data-id="element-166">{t.developer.pibasa.p2}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionReveal>;
}